// extracted by mini-css-extract-plugin
export var _default = "big_section-module--_default--sU6k4";
export var primary = "big_section-module--primary--q5rsd";
export var secondary = "big_section-module--secondary--V1Mbv";
export var secondary_display = "big_section-module--secondary_display--TcgrH";
export var sections = "big_section-module--sections--tb0AG";
export var sections_general_text = "big_section-module--sections_general_text--DCCT+";